import { render, staticRenderFns } from "./ProductGlide.vue?vue&type=template&id=65f5be4b&scoped=true&"
import script from "./ProductGlide.vue?vue&type=script&lang=js&"
export * from "./ProductGlide.vue?vue&type=script&lang=js&"
import style0 from "./ProductGlide.vue?vue&type=style&index=0&id=65f5be4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5be4b",
  null
  
)

/* custom blocks */
import block0 from "./ProductGlide.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports